import { useEffect, useRef } from 'react';

const projects = [
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20container%20port%20terminal%20at%20dusk%20in%20Latin%20America%2C%20cranes%20loading%20cargo%20ships%2C%20industrial%20lighting%2C%20dark%20sky%20with%20warm%20golden%20highlights%2C%20professional%20industrial%20photography%2C%20high%20contrast%2C%20corporate%20investment%20project&width=800&height=600&seq=project-port-01&orientation=landscape',
    title: 'Proyectos Portuarios',
    sector: 'Logística',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20boutique%20hotel%20exterior%20at%20night%20in%20Andean%20region%2C%20modern%20architecture%20with%20warm%20interior%20lighting%20glowing%20through%20windows%2C%20mountain%20backdrop%2C%20premium%20hospitality%20photography%2C%20dark%20atmospheric%20mood%2C%20golden%20accent%20lights&width=800&height=600&seq=project-hotel-01&orientation=landscape',
    title: 'Proyectos Hoteleros',
    sector: 'Hotelería',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20agricultural%20processing%20plant%20aerial%20view%2C%20industrial%20greenhouses%20and%20processing%20facilities%20in%20rural%20Latin%20America%2C%20organized%20crop%20fields%2C%20golden%20sunset%20lighting%2C%20professional%20drone%20photography%2C%20corporate%20investment%20project%20documentation&width=800&height=600&seq=project-agro-01&orientation=landscape',
    title: 'Proyectos Agriculas',
    sector: 'Agroindustria',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20hospital%20building%20exterior%20in%20Latin%20America%2C%20contemporary%20healthcare%20architecture%20with%20glass%20facade%2C%20warm%20evening%20lighting%2C%20clean%20medical%20campus%20design%2C%20professional%20architectural%20photography%2C%20dark%20sky%20with%20golden%20hour%20tones%2C%20corporate%20investment%20healthcare%20infrastructure%2C%20elegant%20and%20modern%20aesthetic&width=800&height=600&seq=project-hospital-01&orientation=landscape',
    title: 'Proyectos Hospitalarios',
    sector: 'Salud',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20high-rise%20residential%20complex%20in%20Latin%20American%20city%2C%20luxury%20apartments%20with%20glass%20balconies%2C%20warm%20evening%20lighting%20in%20windows%2C%20dark%20sky%20background%2C%20urban%20development%20project%2C%20premium%20real%20estate%20photography%2C%20corporate%20investment%20visual&width=800&height=600&seq=project-residential-01&orientation=landscape',
    title: 'Proyectos Inmobiliarios',
    sector: 'Inmobiliario',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Solar%20energy%20farm%20at%20sunset%20in%20Andean%20landscape%2C%20rows%20of%20solar%20panels%20with%20mountain%20backdrop%2C%20warm%20golden%20light%20reflecting%20on%20panels%2C%20renewable%20energy%20infrastructure%20project%2C%20professional%20drone%20photography%2C%20corporate%20investment%20documentation%20quality&width=800&height=600&seq=project-energy-01&orientation=landscape',
    title: 'Proyecto de Energía Solar',
    sector: 'Energía',
  },
];

export default function ProjectsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.project-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('animate-fade-in-up');
                (card as HTMLElement).style.opacity = '1';
              }, i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="proyectos" className="relative bg-aa-black-soft py-16 md:py-24 overflow-hidden">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="mb-12 md:mb-16">
            <span className="label-tag block mb-4">CARTERA DE INVERSIÓN</span>
            <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold">
              Proyectos
              <br />
              <span className="gold-text-gradient">Estratégicos</span>
            </h2>
          </div>

          {/* Projects Grid */}
          <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {projects.map((project, index) => (
              <div
                key={index}
                className="project-card opacity-0 rounded-2xl overflow-hidden bg-aa-black-card border border-aa-gold/10 group gold-border-glow"
              >
                <div className="relative overflow-hidden h-52 md:h-56">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-aa-black/80 to-transparent" />
                  <span className="absolute top-4 left-4 bg-aa-gold/20 text-aa-gold text-xs uppercase tracking-wider font-medium px-3 py-1 rounded-full border border-aa-gold/30">
                    {project.sector}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-white font-semibold text-lg group-hover:text-aa-gold transition-colors">
                    {project.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}